module.exports = __webpack_public_path__ + "static/media/gastro-main-1.2ea55e79.jpg";